<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>

<div class="ops">
	<!-- Pipeline: every status and how many billets are in it, plus what's late -->
	<div class="pipeline">
		<div *ngFor="let col of columns; let last = last" class="stage" [ngClass]="'st-' + col.key" [title]="col.count + ' ' + col.statusName">
			<i class="far stage-icon" [ngClass]="col.icon"></i>
			<b>{{ col.count }}</b>
			<i *ngIf="!last" class="fal fa-chevron-right arrow"></i>
		</div>
		<div class="alerts">
			<div class="alert alert-overdue" [class.muted]="overdueCount === 0"><i class="fal fa-exclamation-triangle"></i><b>{{ overdueCount }}</b> Overdue</div>
			<div class="alert alert-soon" [class.muted]="dueSoonCount === 0"><i class="fal fa-hourglass-half"></i><b>{{ dueSoonCount }}</b> Due this week</div>
		</div>
	</div>

	<div class="hint"><i class="fal fa-hand-pointer"></i> Drag a billet to change its status - or drag a tool's header to move all of its billets together.</div>

	<toolroom-loader *ngIf="isLoading" text="Loading the board" variant="draw"></toolroom-loader>

	<div class="board">
		<!-- Tools with no billets at all: nothing has been broken down for them yet, so they appear before the
		     first status rather than inside it. Nothing to drag here - open the tool to add its billets. -->
		<div class="col col-design">
			<div class="col-head">
				<span class="col-name"><span class="col-icon"><i class="far fa-inbox"></i></span>To design</span>
				<span class="col-count">{{ toolsToDesign.length }}</span>
			</div>
			<div class="col-body">
				<div *ngFor="let tool of toolsToDesign" class="tool tool-todesign" (click)="goToTool(tool.toolId)" title="Open tool to add its billets">
					<div class="tool-head">
						<span class="tool-thumb">
							<img *ngIf="tool.imageUrl" [src]="tool.imageUrl" alt="Tool" />
							<i *ngIf="!tool.imageUrl" class="fal fa-tools"></i>
						</span>
						<span class="tool-name">{{ tool.toolName }}</span>
					</div>
					<div class="todesign-meta">
						<span *ngIf="tool.clientName" class="todesign-client">{{ tool.clientName }}</span>
						<span *ngIf="tool.dateRequired" class="tag tag-due" [ngClass]="tool.dueState">
							<i class="fal" [class.fa-exclamation-triangle]="tool.dueState === 'overdue'" [class.fa-calendar]="tool.dueState !== 'overdue'"></i>
							{{ tool.dateRequired | date:'dd/MM' }}
						</span>
						<span class="todesign-note">No billets</span>
					</div>
				</div>
				<div *ngIf="toolsToDesign.length === 0" class="col-empty">Every tool has billets</div>
			</div>
		</div>

		<div *ngFor="let col of columns" class="col" [ngClass]="'st-' + col.key" [class.drag-over]="dragOverStatus === col.status"
			(dragover)="onDragOver($event, col.status)" (dragleave)="onDragLeave(col.status)" (drop)="$event.preventDefault(); onDrop(col.status)">

			<div class="col-head">
				<span class="col-name"><span class="col-icon"><i class="far" [ngClass]="col.icon"></i></span>{{ col.statusName }}</span>
				<span class="col-count">{{ col.count }}</span>
			</div>

			<div class="col-body">
				<div *ngFor="let tool of col.tools" class="tool" [class.dragging]="draggingType === 'tool' && draggingToolId === tool.toolId">
					<div class="tool-head" draggable="true" (dragstart)="onToolDragStart($event, tool.toolId)" (dragend)="onDragEnd()" title="Drag to move all of this tool's billets">
						<span class="tool-thumb" (click)="goToTool(tool.toolId)" title="Open tool">
							<img *ngIf="tool.imageUrl" [src]="tool.imageUrl" alt="Tool" />
							<i *ngIf="!tool.imageUrl" class="fal fa-tools"></i>
						</span>
						<span class="tool-name">{{ tool.toolName }}</span>
						<span class="tool-count">{{ tool.blocks.length }}</span>
					</div>

					<div *ngFor="let block of tool.blocks" class="billet" draggable="true"
						[class.dragging]="draggingType === 'block' && draggingBlockId === block.id"
						[class.overdue]="block.dueState === 'overdue'"
						(dragstart)="$event.stopPropagation(); onBlockDragStart($event, block)" (dragend)="onDragEnd()"
						(click)="goToBlock(block.id)">
						<span class="billet-thumb">
							<img *ngIf="block.imageUrl" [src]="block.imageUrl" alt="Billet" />
							<i *ngIf="!block.imageUrl" class="fal fa-cube"></i>
						</span>
						<div class="billet-body">
							<div class="billet-name">{{ block.name || ('Billet ' + block.id) }}</div>
							<div class="billet-tags">
								<span *ngIf="block.dateRequired" class="tag tag-due" [ngClass]="block.dueState">
									<i class="fal" [class.fa-exclamation-triangle]="block.dueState === 'overdue'" [class.fa-calendar]="block.dueState !== 'overdue'"></i>
									{{ block.dateRequired | date:'dd/MM' }}
								</span>
							</div>
							<div *ngIf="block.progress" class="progress" [title]="block.progress.done + ' of ' + block.progress.total + ' operations complete'">
								<div class="progress-track"><div class="progress-fill" [style.width.%]="block.progress.percent"></div></div>
								<span>{{ block.progress.done }}/{{ block.progress.total }}</span>
							</div>
						</div>
					</div>
				</div>
				<div *ngIf="col.tools.length === 0" class="empty"><i class="fal fa-inbox"></i> No billets</div>
			</div>
		</div>
	</div>
</div>
